const state = {
  referral: {
    results: [],
    currentFilters: null, //Usage in Search.vue
    paging: {
      perPage: 15,
      currentPage: 1,
      totalItemCount: 0,
      pageCount: 0,
      count: 0
    },
    columns: [],
    filters: {
      isAdvancedFilter: false,
      //Collections
      //All
      academicyears: [],
      //Standard
      schools: [],
      serviceModalityTypes: [],
      //Standard & Advanced
      municipalities: [],
      //Standard & Waiting List
      disciplines: [],
      centers: [],
      //Standard & Advanced
      admissionStatusReasons: [],
      admissionStatus: [],
      admissionReferralTypes: [],
      //Advance collections
      months: [],
      providers: [],
      locationTypes: [],
      locationServices: [],
      specialists: [],
      //Selected
      currentFilters: {
        selectedAcademicYearByFilters: null,
        selectedAcademicYear: null, //Deprecated?
        selectedDiscipline: null,
        selectedCenter: null,
        selectedMunicipality: null,
        selectedSchool: null,
        selectedAdmissionStatusReason: null,
        selectedAdmissionStatus: null,
        selectedAdmissionReferralType: null,
        //Selected Advanced
        selectedProvider: null,
        selectedMonth: null,
        selectedLocationType: null,
        selectedLocationService: null,
        selectedSpecialist: null
      },
      filters: [
        { id: 1, value: 0, name: "Estándar" },
        { id: 2, value: 1, name: "Alertas" },
        { id: 3, value: 2, name: "Avanzado" },
        { id: 4, value: 3, name: "Lista de Espera" },
        { id: 5, value: 5, name: "Servicios Otros" }
      ],
      selectedFilter: null,
      searchText: "",
      radioBtnSelected: null,
      selectedFilterType: 1,
      lastFiltered: {}
    },
    serviceCenters: [],
    rejectionReasons: []
  },
  link: {
    admissionrejectionhistory: {},
    providerDetail: {},
    providerCenters: [],
    providerSchools: [],
    providerReasons: [],
    municipalitiesSchool: [],
    municipalitiesHome: [],
    municipalitiesHomeSchools: [],
    municipalitiesFreeSelection: [],
    municipalitiesFreeSelectionSchools: []
  }
};
export default state;
